import { Frown } from "lucide-react";
import { FC } from "react";

type EmptyStateProps = {
  title?: string
  text?: string
  icon?: React.ReactNode
};

const NoResult: FC<EmptyStateProps> = ({
  title = "Aucun résultat trouvé",
  text = "Essayez de modifier vos filtres ou votre recherche.",
  icon = <Frown size={40} className=" mb-4" />,
}) => {
  return (
    <div className="flex flex-col items-center justify-center text-center py-24 px-4">
      {icon}
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="text-muted-foreground mt-2 max-w-md">{text}</p>
    </div>
  );
};

export default NoResult;
